/**
 * This file contains some syntactic-sugar wrappers for making HeadlingLevelBoundary
 * easier to work with.
 */

import React, { forwardRef } from 'react';
import HeadingLevelBoundary, {
  ElementProps as Props,
} from './HeadingLevelBoundary';

/**
 * Render a `section` tag and handle updating the heading level context
 */
const Section = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="section" {...props} ref={ref} />
));
Section.displayName = 'Section';

/**
 * Render a `main` tag and handle updating the heading level context
 */
const Main = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="main" {...props} ref={ref} />
));
Main.displayName = 'Main';

/**
 * Render a `nav` tag and handle updating the heading level context
 */
const Nav = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="nav" {...props} ref={ref} />
));
Nav.displayName = 'Nav';

/**
 * Render an `aside` tag and handle updating the heading level context
 */
const Aside = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="aside" {...props} ref={ref} />
));
Aside.displayName = 'Aside';

/**
 * Render an `header` tag and handle updating the heading level context
 */
const Header = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="header" {...props} ref={ref} />
));
Header.displayName = 'Header';

const Footer = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <HeadingLevelBoundary tag="footer" {...props} ref={ref} />
));
Footer.displayName = 'Footer';

export { Section, Main, Nav, Aside, Header, Footer };
export type { Props };
